var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-element-loading',{attrs:{"text":_vm.loading.text,"spinner":"ring","color":_vm.loading.color,"active":_vm.loading.active,"is-full-screen":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }